/* eslint-disable react/prop-types */
import React, { Fragment } from 'react'
import { Container, makeStyles } from '@material-ui/core'
import Header from '@components/Affiliate/Header'
import Pattern from '@assets/images/pattern2.webp'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    background: '#F3F3F3',
    paddingBottom: '4rem',
  },
  space: {
    backgroundColor: '#676767',
    position: 'absolute',
    top: 0,
    width: '100%',
    height: 400,
  },
  patternImg: {
    position: 'absolute',
    top: 100,
    width: '100%',
  },
  content: {
    marginTop: 90,
    zIndex: 1,
    minHeight: 'calc(100vh - 90px)',
    position: 'relative',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: 260,
      background: `url(${Pattern})`,
      backgroundSize: '',
      zIndex: -1,
    },
  },
}))

const DashboardLayout = ({ children }) => {
  const classes = useStyles()

  return (
    <Fragment>
      <Header />
      <div className={classes.root}>
        <Container maxWidth="xl" className={classes.content}>
          {children}
        </Container>
      </div>
    </Fragment>
  )
}
export default DashboardLayout
